<template>
    <div>
        <MapLeaflet :data="data" v-if="status == 'success'"></MapLeaflet>
    </div>
</template>

<script setup>
definePageMeta({
    auth: false,
    middleware: ['set-cookie'],
});
const token = useCookie('auth.public-token')
const { $publicToken } = useNuxtApp();
const { data, status, error, refresh, clear } = await useAsyncData('thongtinMap', () => $fetch(`/api/map/thong-tin?token=${$publicToken}`,
    {
        method: 'GET',
        headers: {
            ...useRequestHeaders(['cookie']),
        },
    }));

if (error.value) {
    throw showError(error.value)
}
</script>

<style>
#map {
    width: 100%;
    height: 500px;
}
</style>
